import React from "react";
import { Grid, Typography, RadioGroup, FormControlLabel, Radio } from "@mui/material";

export default function ClosedRecruitmentField({ value, onChange }) {
  const handleChange = (event) => {
    onChange({ close_check: Number(event.target.value) });
  };

  return (
    <Grid container justifyContent="center">
      <Grid
        item
        xs={12}
        sx={{
          paddingLeft: "10px",
          paddingTop: "10px",
          paddingBottom: "20px",
          fontSize: 16,
        }}
      >
        <RadioGroup value={value} row onChange={handleChange}>
          <FormControlLabel
            value={1}
            label={<Typography>クローズした案件を含まない</Typography>}
            control={<Radio sx={{ "&.Mui-checked": { color: "#28345E" } }} />}
          />
          <FormControlLabel
            value={2}
            label={<Typography>クローズした案件</Typography>}
            control={<Radio sx={{ "&.Mui-checked": { color: "#28345E" } }} />}
          />
          <FormControlLabel
            value={3}
            label={<Typography>クローズを含む全案件</Typography>}
            control={<Radio sx={{ "&.Mui-checked": { color: "#28345E" } }} />}
          />
        </RadioGroup>
      </Grid>
    </Grid>
  );
}